import { Text } from "@chakra-ui/react";
import * as React from "react";

import { useWorkspaceURL } from "../hooks";
import Link from "./link";

export default function ConnectFacebookHelperText() {
  const workspaceURL = useWorkspaceURL();
  return (
    <Text>
      You have to{" "}
      <Link to={workspaceURL(`settings/integrations`)}>
        connect your Facebook
      </Link>{" "}
      account before proceeding.
    </Text>
  );
}
